export enum CardType {
  Current = 1,
  Shutdown = 4,
  Startup = 17,
}
